<template lang="pug">
.base-tooltip(:class="{ show, dark, noWrap, [position]: true }") {{ text }}
  slot
</template>

<script>
export default {
  name: 'BaseTooltipDropdown', // todo rename to TooltipDropdown and use it with TooltipIcon
  props: {
    show: Boolean,
    dark: Boolean,
    noWrap: Boolean,
    text: String,
    position: {
      type: String,
      default: 'bottom',
      validator(value) {
        return ['top', 'left', 'right', 'bottom'].indexOf(value) !== -1;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.base-tooltip {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index: 50;
  padding: 20px;
  background-color: var(--color-white);
  color: var(--color-middle-gray);
  border-radius: 6px;
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.12);
  font-size: 14px;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  //filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.08)), drop-shadow(0 15px 30px rgba(0, 0, 0, 0.12));

  $triangleWidth: 32px;
  $triangleHeight: 16px;
  &:before {
    content: "";
    display: inline-block;
    position: absolute;
    width: 32px;
    height: 16px;
    background-image: url(../assets/img/svg/triangle.svg);
    background-size: cover;
    background-repeat: no-repeat;
  }

  &.dark {
    background-color: rgba(30, 49, 71, 0.9);
    color: rgba(255, 255, 255, 1);

    &:before {
      display: none;
    }
  }

  &.noWrap {
    white-space: nowrap;
  }

  &.show {
    opacity: 1;
    visibility: visible;
  }

  &.top, &.bottom { left: 50%; transform: translateX(-50%); }
  &.left, &.right { top: 50%; transform: translateY(-50%); }

  &.top { bottom: calc(100% + 20px); }
  &.bottom { top: calc(100% + 20px); }
  &.left { right: calc(100% + 20px); }
  &.right { left: calc(100% + 20px); }

  &.top:before {
    top: 100%;
    left: 50%;
    transform: translateX(-50%) rotate(180deg);
  }

  &.bottom:before {
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
  }

  $triangleShift: ($triangleWidth - $triangleHeight) / 2;
  &.right:before {
    right: calc(100% - #{$triangleShift});
    top: 50%;
    transform: translateY(-50%) rotate(270deg);
  }

  &.left:before {
    left: calc(100% - #{$triangleShift});
    top: 50%;
    transform: translateY(-50%) rotate(90deg);
  }
}

</style>
